<ng-container *transloco="let t;">
    <app-contract-control-graph [skeletonName]="'dashboard_Contract_Event_Loader'" height="170px" [status]="1" [filterVisible]="true" heading="{{ t('Contract envent graph title (Contract Control graph) - Contract events') }}"></app-contract-control-graph>
</ng-container>